import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Input,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
import { ContentCopy } from "mdi-material-ui";
import locale from "@bonliva-crm/locale";
import PrimaryButton from "@components/buttons/PrimaryButton";
import clipboard from "@utils/clipboard";
import WithTooltip from "@components/WithTooltip";

export type UploadedFile = {
  name: string;
  url: string;
};

type Props = {
  onClose: () => void;
  open: boolean;
  files: UploadedFile[];
};

const SharedFilesUploadedDialog: React.FC<Props> = (props) => {
  return (
    <Dialog
      open={props.open}
      fullWidth
      maxWidth="sm"
      TransitionProps={{
        mountOnEnter: true,
        unmountOnExit: true
      }}
      onBackdropClick={props.onClose}
    >
      <DialogTitle>{locale.FileUploadSuccess}</DialogTitle>
      <DialogContent id="filesUploadedDialog">
        <List>
          {props.files.map((file, idx) => (
            <ListItem key={idx} style={{ paddingLeft: 0, paddingRight: 0 }}>
              <ListItemText style={{ overflow: "hidden", marginRight: 8 }}>
                {file.name}
              </ListItemText>
              <Input
                value={file.url}
                onClick={() => clipboard(file.url)}
                style={{ minWidth: 150, maxWidth: 150 }}
                title={locale.CopyToClipboard}
                readOnly
              />
              <ListItemIcon>
                <WithTooltip title={locale.CopyToClipboard}>
                  <IconButton
                    onClick={() => {
                      clipboard(file.url, document.getElementById("filesUploadedDialog"));
                    }}
                  >
                    <ContentCopy />
                  </IconButton>
                </WithTooltip>
              </ListItemIcon>
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions style={{ justifyContent: "center" }}>
        <PrimaryButton onClick={props.onClose}>{locale.OK}</PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default SharedFilesUploadedDialog;
